"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _framerMotion = require("framer-motion");

var _Backdrop = _interopRequireDefault(require("../Backdrop"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _UserMenu = _interopRequireDefault(require("../UserMenu"));

var _DesktopNav = require("./DesktopNav.style");

var DesktopNav = function DesktopNav(_ref) {
  var account = _ref.account,
      actions = _ref.actions,
      activePath = _ref.activePath,
      homeLink = _ref.homeLink,
      logoImage = _ref.logoImage,
      primaryLinks = _ref.primaryLinks,
      secondaryLinks = _ref.secondaryLinks,
      accessibility = _ref.accessibility;
  var hoverTimer = (0, _react.useRef)(null);

  var _ref2 = (0, _react.useState)(''),
      _ref3 = _slicedToArray(_ref2, 2),
      activeItem = _ref3[0],
      setActiveItem = _ref3[1];

  var debounce = function debounce(callback) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(function () {
      callback();
    }, time);
  };

  var showDropdown = function showDropdown(name) {
    return setActiveItem(name);
  };

  var hideDropdown = function hideDropdown() {
    return setActiveItem('');
  };

  var activeMenuProps = {
    activeItem: activeItem,
    onItemClick: hideDropdown,
    onItemHoverStart: function onItemHoverStart(name) {
      return debounce(function () {
        return showDropdown(name);
      });
    },
    onItemHoverEnd: function onItemHoverEnd() {
      return debounce(function () {
        return hideDropdown();
      });
    },
    pathname: activePath
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, {
    initial: false,
    exitBeforeEnter: true
  }, !!activeItem && /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
    onClick: hideDropdown
  })), /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    homeLink: homeLink,
    logoImage: logoImage
  }), /*#__PURE__*/_react.default.createElement(_Menu.default, Object.assign({
    items: primaryLinks,
    menuTitle: accessibility === null || accessibility === void 0 ? void 0 : accessibility.primaryMenuLabel
  }, activeMenuProps))), /*#__PURE__*/_react.default.createElement(_DesktopNav.MenuWrapper, null, secondaryLinks && secondaryLinks.length > 0 && /*#__PURE__*/_react.default.createElement(_Menu.default, Object.assign({
    dropdownDirection: "right",
    items: secondaryLinks,
    menuTitle: accessibility === null || accessibility === void 0 ? void 0 : accessibility.secondaryMenuLabel
  }, activeMenuProps)), actions && actions.length > 0 && !account && actions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_DesktopNav.NavCta, Object.assign({
      key: action.label,
      variant: "primary"
    }, action), action.label);
  }), account && /*#__PURE__*/_react.default.createElement(_UserMenu.default, Object.assign({
    menuTitle: accessibility === null || accessibility === void 0 ? void 0 : accessibility.userMenuLabel
  }, activeMenuProps, account))));
};

DesktopNav.propTypes = {
  /** Object defining account area, avatar property is used to control display of the avatar circle, either with image or name, menu is the array of items supplied to the dropdown menu */
  account: _propTypes.default.shape({
    avatar: _propTypes.default.shape({
      image: _propTypes.default.shape({
        /** Fluid image object */
        fluid: _propTypes.default.shape({
          base64: _propTypes.default.string.isRequired,
          aspectRatio: _propTypes.default.number.isRequired,
          src: _propTypes.default.string.isRequired,
          srcSet: _propTypes.default.string.isRequired,
          srcSetWebp: _propTypes.default.string.isRequired,
          sizes: _propTypes.default.string.isRequired
        }),

        /** File src of image object in case we dont have a fluid obj */
        src: _propTypes.default.string
      }),
      name: _propTypes.default.string
    }),
    menu: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      onClick: _propTypes.default.func,
      url: _propTypes.default.string
    }))
  }),

  /** Array of objects defining Call to Actions (Buttons) */
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string
  })),

  /** Pathname of the active item, used to determine the the active item, if not specified or there is no match with any of the nav links, no item wil be marked as active */
  activePath: _propTypes.default.string,

  /** Home address of the page, this typically be '/' */
  homeLink: _propTypes.default.string,

  /** Image object allowing to replace the theme logo with a custom one */
  logoImage: _propTypes.default.shape({
    /** Fluid image object */
    fluid: _propTypes.default.shape({
      base64: _propTypes.default.string.isRequired,
      aspectRatio: _propTypes.default.number.isRequired,
      src: _propTypes.default.string.isRequired,
      srcSet: _propTypes.default.string.isRequired,
      srcSetWebp: _propTypes.default.string.isRequired,
      sizes: _propTypes.default.string.isRequired
    }),

    /** File src of image object in case we dont have a fluid obj */
    src: _propTypes.default.string
  }),

  /** Array of objects defining Primary Nav Menu. onClick callback is optional but useful for implementing things like tracking */
  primaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),

  /** Array of objects defining Secondary Nav Menu (Actions Menu). onClick callback is optional but useful for implementing things like tracking */
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    url: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      description: _propTypes.default.string,
      label: _propTypes.default.string,
      url: _propTypes.default.string,
      onClick: _propTypes.default.func
    }))
  })),
  accessibility: _propTypes.default.shape({
    /** Accessibility label for the primary menu */
    primaryMenuLabel: _propTypes.default.string,

    /** Accessibility label for the secondary menu */
    secondaryMenuLabel: _propTypes.default.string,

    /** Accessibility label for the user menu */
    userMenuLabel: _propTypes.default.string
  })
};
DesktopNav.defaultProps = {
  account: null,
  actions: [],
  activePath: '',
  homeLink: '/',
  logoImage: null,
  primaryLinks: [],
  secondaryLinks: [],
  accessibility: null
};
var _default = DesktopNav;
exports.default = _default;